import React, { useEffect, useMemo, useState } from 'react';
import CrackEffect from './easter/CrackEffect';
import WormEffect from './easter/WormEffect';
import BeetleEffect from './easter/BeetleEffect';
import FireworksEffect from './easter/FireworksEffect';
import CrosshairEffect from './easter/CrosshairEffect';

const effectsList = ['crack', 'worm', 'fireworks', 'beetle', 'crosshair'];

const EasterEggOverlay = ({ effect, onClose }) => {
  const [holes, setHoles] = useState([]);
  const durations = {
    crack: 9000,
    worm: 16000,
    fireworks: 7000,
    beetle: 20000,
    crosshair: 12000,
  };

  useEffect(() => {
    const timer = setTimeout(onClose, durations[effect] || 8000);
    return () => clearTimeout(timer);
  }, [effect, onClose, durations]);

  const handleHole = (pos) => {
    setHoles((prev) => [...prev.slice(-6), pos]); // ограничим до 7 дыр
  };

  const overlayContent = useMemo(() => {
    switch (effect) {
      case 'crack':
        return <CrackEffect />;
      case 'worm':
        return <WormEffect />;
      case 'fireworks':
        return <FireworksEffect />;
      case 'beetle':
        return <BeetleEffect />;
      case 'crosshair':
        return <CrosshairEffect onHole={handleHole} />;
      default:
        return null;
    }
  }, [effect]);

  return (
    <div className="egg-overlay" role="presentation">
      <style>{`
        @keyframes egg-crack {
          from { transform: scale(1); filter: grayscale(0); }
          to { transform: scale(1.02); filter: grayscale(0.4); }
        }
        @keyframes egg-walk {
          0% { transform: translate(-30%, 30%); opacity: 1; }
          100% { transform: translate(120%, -60%); opacity: 1; }
        }
        @keyframes egg-beetle {
          0% { transform: translate(-40%, 0) rotate(-2deg); opacity: 1; }
          70% { transform: translate(55%, 0) rotate(2deg); opacity: 1; }
          85% { transform: translate(60%, -4%) rotate(3deg); opacity: 0.9; }
          100% { transform: translate(65%, -8%) rotate(5deg); opacity: 0; }
        }
        @keyframes fw-burst {
          0% { transform: scale(0); opacity: 1; }
          60% { transform: scale(1); opacity: 1; }
          100% { transform: scale(1.2); opacity: 0; }
        }
        .egg-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.05);
          z-index: 2000;
          backdrop-filter: blur(1px);
          pointer-events: none;
        }
        .egg-ui {
          position: fixed;
          inset: 0;
          pointer-events: none;
        }
        .egg-close {
          position: fixed;
          top: 12px;
          right: 12px;
          background: rgba(0,0,0,0.65);
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 8px 12px;
          cursor: pointer;
          pointer-events: auto;
          font-size: 12px;
        }
        .egg-label {
          position: fixed;
          top: 12px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,0.55);
          color: #fff;
          border-radius: 10px;
          padding: 8px 14px;
          font-size: 13px;
          pointer-events: none;
        }
        .egg-worm, .egg-beetle {
          position: absolute;
          top: 58%;
          left: -15%;
          font-size: 64px;
          animation: egg-walk 12s linear forwards;
          user-select: none;
        }
        .egg-beetle { top: 68%; animation: egg-beetle 16s linear forwards; }

        .egg-slime {
          pointer-events: none;
          opacity: 0.7;
        }

        .egg-fireworks {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }
        .egg-fireworks .fw {
          position: absolute;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: radial-gradient(circle, #ffdd57 0%, rgba(255,221,87,0) 70%);
          box-shadow:
            0 0 12px rgba(255,221,87,0.8),
            0 0 24px rgba(255,150,87,0.6),
            0 0 36px rgba(120,120,255,0.5);
          animation: fw-burst 1.5s ease-out infinite;
          mix-blend-mode: screen;
        }
        .fw1 { top: 30%; left: 40%; animation-delay: 0s; }
        .fw2 { top: 50%; left: 60%; animation-delay: 0.3s; }
        .fw3 { top: 20%; left: 70%; animation-delay: 0.6s; }
        .fw4 { top: 65%; left: 25%; animation-delay: 0.9s; }
        .fw5 { top: 35%; left: 15%; animation-delay: 1.1s; }

        .egg-crosshair {
          position: absolute;
          inset: 0;
          cursor: crosshair;
          pointer-events: auto;
        }
        .egg-crosshair-hint {
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,0.6);
          color: #fff;
          padding: 6px 10px;
          border-radius: 8px;
          font-size: 12px;
          pointer-events: none;
        }
        .egg-hole {
          position: absolute;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: radial-gradient(circle at 40% 40%, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0) 70%);
          box-shadow: inset 0 0 8px rgba(0,0,0,0.6);
          pointer-events: none;
        }
      `}</style>
      {overlayContent}
      <div className="egg-ui">
        <div className="egg-label">Пасхалка: {effect}</div>
        <button className="egg-close" onClick={onClose}>Закрыть</button>
      </div>
      {effect === 'crosshair' &&
        holes.map((h, idx) => (
          <div
            key={`${h.x}-${h.y}-${idx}`}
            className="egg-hole"
            style={{ left: h.x - 18, top: h.y - 18 }}
          />
        ))}
    </div>
  );
};

export { effectsList };
export default EasterEggOverlay;

